<template>
    <div id="loader">
        <div class="row justify-content-center p-3" v-show="loading_status">
            <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'loader',
        props: ['loading'],
        computed: {
            loading_status: {
                get: function() {
                    return this.loading ? this.loading : false;
                },
                set: function(newVal) {
                    return newVal;
                }
            }
        },
        watch: {
            loading: function(newVal) {
                this.loading = newVal;
            }
        }
    }
</script>